/**
 * --------------------------------------------------
 * components/FilterNavigation.ts
 * Filter Navigation
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class FilterNavigation extends ThemeComponent {
    @Ref({required: false}) navigationLinks!: HTMLAnchorElement[];

    init() {
        if (this.navigationLinks) {
            for (const link of this.navigationLinks) {
                if (link.classList.contains('group-filter__button--active')) {
                    link.scrollIntoView(false);
                }
            }
        }
    }
}
